import type { PickerColumn } from 'react-vant';
import { TagType } from 'react-vant/es/Tag/PropsType';

interface IOperationListType {
  key: string;
  label: string;
  img: string;
  redirectUrl: string;
}

export enum rendAndSaleEnum {
  RENT_REQUEST = 'RENT_REQUEST',
  SALE = 'SALE',
  MINE = 'MINE',
}

export enum publishAuditStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  FAILED = 'FAILED',
}

export const publishAuditStatusMap: Record<publishAuditStatusEnum, string> = {
  [publishAuditStatusEnum.PENDING]: '待审核',
  [publishAuditStatusEnum.APPROVED]: '已通过',
  [publishAuditStatusEnum.FAILED]: '未通过',
};

export const publishAuditStatusTagType: Record<
  publishAuditStatusEnum,
  TagType
> = {
  [publishAuditStatusEnum.PENDING]: 'default',
  [publishAuditStatusEnum.APPROVED]: 'success',
  [publishAuditStatusEnum.FAILED]: 'danger',
};

export const publishTypeMap: any = {
  sale: '售房',
  rent: '租房',
};
//房屋类型
export const houseTypeList = [
  {
    label: '平房',
    value: '平房',
  },
  {
    label: '普通住宅',
    value: '普通住宅',
  },
  {
    label: '公寓',
    value: '公寓',
  },
  {
    label: '别墅',
    value: '别墅',
  },
  {
    label: '商住两用',
    value: '商住两用',
  },
];
//房屋朝向
export const houseFacingList = [
  {
    label: '南北通透',
    value: '南北通透',
  },
  {
    label: '面朝南',
    value: '面朝南',
  },

  {
    label: '面朝北',
    value: '面朝北',
  },
  {
    label: '东西朝向',
    value: '东西朝向',
  },
];
//装修情况
export const houseDecorationList = [
  {
    label: '毛坯房',
    value: '毛坯房',
  },
  {
    label: '简单装修',
    value: '简单装修',
  },
  {
    label: '中等装修',
    value: '中等装修',
  },
  {
    label: '精装修',
    value: '精装修',
  },
  {
    label: '豪华装修',
    value: '豪华装修',
  },
];
//房屋布局
export const houseLayoutList = [
  {
    label: '一室一厅',
    value: '一室一厅',
  },
  {
    label: '两室一厅',
    value: '两室一厅',
  },
  {
    label: '三室一厅',
    value: '三室一厅',
  },
  {
    label: '三室两厅',
    value: '三室两厅',
  },
  {
    label: '一室一厅一卫',
    value: '一室一厅一卫',
  },
  {
    label: '两室两厅一卫',
    value: '两室两厅一卫',
  },
  {
    label: '三室两厅两卫',
    value: '三室两厅两卫',
  },
];
//房屋楼层
export const houseStoreyList = [
  {
    label: '低层(1-6)',
    value: '低层(1-6)',
  },
  {
    label: '中层(7-12)',
    value: '中层(7-12)',
  },
  {
    label: '中高层(13-23)',
    value: '中高层(13-23)',
  },
  {
    label: '高层(24-33)',
    value: '高层(24-33)',
  },
];

export const mockSaleData = [
  {
    id: Math.random(),
    title: '高楼层拎包入住',
    type: '整租',
    communityName: '智慧小区',
    price: 2000,
    phone: '18978786756',
    tag: ['面朝南', '普通住宅', '精装修'],
    houseType: '两室一厅',
    area: '120m²',
    auditStatus: publishAuditStatusEnum.PENDING,
  },
  {
    id: Math.random(),
    title: '高楼层拎包入住',
    type: '合租',
    communityName: '智慧小区',
    price: 2000,
    phone: '18978786756',
    tag: ['面朝南', '普通住宅', '精装修'],
    houseType: '两室一厅',
    area: '120m²',
    auditStatus: publishAuditStatusEnum.APPROVED,
  },
  {
    id: Math.random(),
    title: '高楼层拎包入住',
    type: '出售',
    communityName: '智慧小区',
    price: 2000,
    phone: '18978786756',
    tag: ['面朝南', '普通住宅', '精装修'],
    houseType: '两室一厅',
    area: '120m²',
    auditStatus: publishAuditStatusEnum.FAILED,
  },
  {
    id: Math.random(),
    title: '高楼层拎包入住',
    type: '整租',
    communityName: '智慧小区',
    price: 2000,
    phone: '18978786756',
    tag: ['面朝南', '普通住宅', '精装修'],
    houseType: '两室一厅',
    area: '120m²',
    auditStatus: publishAuditStatusEnum.APPROVED,
  },
  {
    id: Math.random(),
    title: '高楼层拎包入住',
    type: '整租',
    communityName: '智慧小区',
    price: 2000,
    phone: '18978786756',
    tag: ['面朝南', '普通住宅', '精装修'],
    houseType: '两室一厅',
    area: '120m²',
    auditStatus: publishAuditStatusEnum.APPROVED,
  },
];

export const operationList: IOperationListType[] = [
  {
    label: '待审核',
    key: '1',
    img: require('@/assets/user/Group 427320643@2x.png'),
    redirectUrl: '/warranty',
  },
  {
    label: '处理中',
    key: '2',
    img: require('@/assets/user/Group 427320644@2x.png'),
    redirectUrl: '/warranty',
  },
  {
    label: '被退回',
    key: '3',
    img: require('@/assets/user/Group 427320645@2x.png'),
    redirectUrl: '/warranty',
  },
  {
    label: '已关闭',
    key: '4',
    img: require('@/assets/user/Group 427320646@2x.png'),
    redirectUrl: '/warranty',
  },
  {
    label: '已完成',
    key: '5',
    img: require('@/assets/user/Group 427320646@2x(1).png'),
    redirectUrl: '/warranty',
  },
  {
    label: '已撤销',
    key: '6',
    img: require('@/assets/user/payBack.png'),
    redirectUrl: '/warranty',
  },
];

export const UserMoreOperationList: IOperationListType[] = [
  {
    label: '小区管理',
    key: '1',
    img: require('@/assets/user/Frame@2x.png'),
    redirectUrl: '/community',
  },
  {
    label: '房屋管理',
    key: '2',
    img: require('@/assets/user/Frame@2x(1).png'),
    redirectUrl: '/house',
  },
  {
    label: '房屋缴费记录',
    key: '3',
    img: require('@/assets/user/Frame@2x(2).png'),
    redirectUrl: '/payment/record',
  },
];

/**
 * 业主留言类型
 */
export const leaveMessageTypeMap: Record<string, string> = {
  1: '业主建议',
  2: '业主投诉',
  3: '业主表扬',
};

export enum leaveMessageStatusEnum {
  /**
   * 待处理
   */
  PENDING = '0',
  /**
   * 已处理
   */
  PROCESSED = '1',
}

export const leaveMessageStatusMap: Record<string, string> = {
  [leaveMessageStatusEnum.PENDING]: '待回复',
  [leaveMessageStatusEnum.PROCESSED]: '已回复',
};

export const leaveMessageTypeList: PickerColumn = [
  {
    text: leaveMessageTypeMap['1'],
    value: '1',
  },
  {
    text: leaveMessageTypeMap['2'],
    value: '2',
  },
  {
    text: leaveMessageTypeMap['3'],
    value: '3',
  },
];
